import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';

import { logo, moon, sun } from '../../assets';
import NavigationLink, { links } from './NavigationLink';
import { GlobalContext } from '../../context/GlobalContext';

const Navbar = ({ bg }) => {
  const navigate = useNavigate();
  const { theme, setTheme } = useContext(GlobalContext);
  const [navBg, setNavBg] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const changeBackground = () => {
      if (window.scrollY >= 100) {
        setNavBg(true);
      } else {
        setNavBg(false);
      }
    };
    window.addEventListener('scroll', changeBackground);

    return () => window.removeEventListener('scroll', changeBackground);
  }, []);

  return (
    <header
      className={`fixed w-full ${bg ? 'bg-white dark:bg-black2' : ''} flex h-[80px] z-[1000] ${(isOpen || navBg)
      && 'bg-white dark:bg-black2 border-b border-gray2 dark:border-black4 '} `}
    >
      <nav className="wrapper flex justify-between items-center">
        <div
          onClick={() => {
            navigate('/');
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
          }}
          className="cursor-pointer"
        >
          <img
            src={logo}
            alt="logo"
            className="w-[45px] hover:rotate-180 hover:brightness-100 transition-all duration-700 brightness-0 dark:brightness-100"
          />
        </div>

        <ul className="hidden md:flex gap-8 text-xs uppercase font-bold text-primaryGray">
          {links.map((link) => (
            <NavigationLink
              key={link.id}
              name={link.name}
              path={link.path}
              offset={link.offset}
            />
          ))}
          <NavLink
            to="/contact"
            className={({ isActive }) => (isActive
              ? 'text-primaryBlack dark:text-primaryBlue' : 'cursor-pointer hover:text-primaryBlack dark:hover:text-primaryBlue')}
          >Contact Me
          </NavLink>
        </ul>

        <div className="flex justify-center items-center">
          <div
            className="cursor-pointer rounded-full flex justify-center items-center mr-8 md:mr-0"
            onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
          >
            <img
              src={sun}
              alt="sun"
              className={`w-[30px] h-[30px] transition-all duration-1000 delay-[.2s]
              ${theme === 'light' && 'rotate-[360deg] scale-0 delay-0'}`}
            />
            <img
              src={moon}
              alt="moon"
              className={`absolute scale-0 w-[30px] h-[30px] transition-all duration-1000 
              ${theme === 'light' && 'rotate-[360deg] scale-100 delay-[.5s]'}`}
            />
          </div>

          {/* Hamburger Icon */}
          <div
            className="flex md:hidden relative w-[30px] h-[30px] px-1 cursor-pointer"
            onClick={() => setIsOpen((prev) => !prev)}
          >
            <div className={`relative w-[30px] h-[20px] m-auto flex items-center rotate-0
          transition-all duration-1000
          ${isOpen ? 'rotate-[315deg]' : ''}`}
            >
              <span
                className={`absolute block w-full h-1 bg-primaryBlack dark:bg-primaryGray rounded-full transition-all duration-300 delay-500
              ${isOpen ? 'scale-x-0 opacity-0 delay-0' : 'scale-x-100 opacity-100'}`}
              />
              <span
                className={`absolute top-0 left-0 block w-1/2 h-1 bg-primaryBlack dark:bg-primaryGray rounded-full translate-y-0 
              transition-all duration-300 delay-500
              ${isOpen ? '!w-full translate-y-2 delay-0' : ''}`}
              />
              <span className={`absolute bottom-0 right-0 block w-1/2 h-1 bg-primaryBlack dark:bg-primaryGray rounded-full 
            transition-all duration-300 rotate-0 delay-500
            ${isOpen ? '!w-full  rotate-90 bottom-2 delay-0' : ''}`}
              />
            </div>
          </div>

        </div>

        {/* mobile menu */}
        <ul
          className={`flex flex-col md:hidden fixed top-[80px] w-full mx-auto p-5 text-center gap-4
          bg-white dark:bg-black2 border-b border-gray2 dark:border-black4 transition-all duration-500 text-sm uppercase font-bold text-primaryGray
          ${isOpen ? 'left-0 right-0' : '-right-full'}`}
        >
          {links.map((link) => (
            <NavigationLink
              key={link.id}
              name={link.name}
              path={link.path}
              offset={link.offset}
              setIsOpen={setIsOpen}
            />
          ))}
          <NavLink
            to="/contact"
            className={({ isActive }) => (isActive
              ? 'text-primaryBlack dark:text-primaryBlue' : 'cursor-pointer hover:text-primaryBlack dark:hover:text-primaryBlue')}
            onClick={() => setIsOpen(false)}
          >Contact Me
          </NavLink>
        </ul>
      </nav>
    </header>
  );
};

export default Navbar;
